<template>
  <div class="cruise-pms-app app-shell" :class="{ 'report-focus': reportFocus }">
    <IdentityWatermark />
    <TopBar v-show="!reportFocus" />
    <div class="app-shell__body">
      <SideBar :collapsed="collapsed" :tabs="tabs" />
      <section class="app-shell__workspace">
        <TagsView
          :tabs="tabs"
          :active-path="route.path"
          :collapsed="collapsed"
          @select="selectTab"
          @close="closeTab"
          @toggle-sidebar="toggleSidebar"
        />
        <el-alert v-if="initializationError" :title="initializationError" type="error" :closable="false" show-icon>
          <el-button :loading="initializing" @click="initialize">重新加载</el-button>
        </el-alert>
        <main ref="main" class="app-main">
          <RouterView v-slot="{ Component, route: viewRoute }">
            <KeepAlive :include="cacheNames">
              <component
                :is="pageHost(viewRoute)"
                v-if="Component"
                :key="viewRoute.path"
                :page="Component"
                :route="viewRoute"
              />
            </KeepAlive>
          </RouterView>
        </main>
      </section>
    </div>
    <MobileBottomNav v-show="!reportFocus" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import IdentityWatermark from "@/components/IdentityWatermark.vue";
import { RouterView, useRoute } from "vue-router";
import MobileBottomNav from "./components/MobileBottomNav.vue";
import SideBar from "./components/SideBar.vue";
import TagsView from "./components/TagsView.vue";
import TopBar from "./components/TopBar.vue";
import { useSystemContextStore } from "@/stores/system-context";
import { useAuthStore } from "@/stores/auth";
import { useMobileViewportInsets } from "@/composables/useMobileViewportInsets";
import { useMobileLayout } from "@/composables/useMobileLayout";
import { useWorkspaceTabs } from "@/composables/useWorkspaceTabs";

useMobileViewportInsets();
const { isMobile } = useMobileLayout();
const route = useRoute();
const main = ref<HTMLElement>();
const { tabs, collapsed, cacheNames, pageHost, selectTab, closeTab, toggleSidebar } = useWorkspaceTabs(main);
const reportFocus = computed(() => isMobile.value && route.name === "personal-report-editor");
const systemContext = useSystemContextStore();
const auth = useAuthStore();
const initializationError = ref("");
const initializing = ref(false);
async function initialize() {
  if (initializing.value) return;
  initializing.value = true;
  try {
    await auth.load();
    await systemContext.load();
    initializationError.value = "";
  } catch {
    initializationError.value = "页面初始化失败，请检查网络连接后重新加载。";
  } finally {
    initializing.value = false;
  }
}
onMounted(initialize);
</script>
